var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTodoZeroState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "69px",
    height: "54px",
    viewBox: "0 0 69 54",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Slice 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-tasklist"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#6F7FE2",
    cx: 11.5,
    cy: 11.5,
    r: 11.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fill: "#6F7FE2",
    cx: 57.5,
    cy: 26.5,
    r: 11.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "8 7 62 7 62 53 8 53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,12 C9.34314575,12 8,10.6568542 8,9 C8,7.8954305 8.8954305,7 10,7 L60,7 C61.1045695,7 62,7.8954305 62,9 C62,10.6568542 60.6568542,12 59,12 L11,12 Z",
    id: "Path",
    fill: "#F0F4FE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,53 L9,53 C8.44771525,53 8,52.5522847 8,52 L8,52 C8,49.790861 9.790861,48 12,48 L59,48 C60.6568542,48 62,49.3431458 62,51 L62,52 C62,52.2652165 61.8946432,52.5195704 61.7071068,52.7071068 C61.5195704,52.8946432 61.2652165,53 61,53 Z",
    id: "Path",
    fill: "#F0F4FE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,6 L10,6 C8.34314575,6 7,7.34314575 7,9 L7,51 C7,52.6568542 8.34314575,54 10,54 L60,54 C61.6568542,54 63,52.6568542 63,51 L63,9 C63,7.34314575 61.6568542,6 60,6 Z M61,51 C61,51.5522847 60.5522847,52 60,52 L10,52 C9.44771525,52 9,51.5522847 9,51 L9,9 C9,8.44771525 9.44771525,8 10,8 L60,8 C60.5522847,8 61,8.44771525 61,9 L61,51 Z",
    id: "Shape",
    fill: "#B2C1DF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,46 C22.4477153,46 22,46.4477153 22,47 L22,49 C22,49.5522847 22.4477153,50 23,50 C23.5522847,50 24,49.5522847 24,49 L24,47 C24,46.4477153 23.5522847,46 23,46 Z M18,46 C17.4477153,46 17,46.4477153 17,47 L17,49 C17,49.5522847 17.4477153,50 18,50 C18.5522847,50 19,49.5522847 19,49 L19,47 C19,46.4477153 18.5522847,46 18,46 Z M13,46 C12.4477153,46 12,46.4477153 12,47 L12,49 C12,49.5522847 12.4477153,50 13,50 C13.5522847,50 14,49.5522847 14,49 L14,47 C14,46.4477153 13.5522847,46 13,46 Z M38,46 C37.4477153,46 37,46.4477153 37,47 L37,49 C37,49.5522847 37.4477153,50 38,50 C38.5522847,50 39,49.5522847 39,49 L39,47 C39,46.4477153 38.5522847,46 38,46 Z M43,46 C42.4477153,46 42,46.4477153 42,47 L42,49 C42,49.5522847 42.4477153,50 43,50 C43.5522847,50 44,49.5522847 44,49 L44,47 C44,46.4477153 43.5522847,46 43,46 Z M48,46 C47.4477153,46 47,46.4477153 47,47 L47,49 C47,49.5522847 47.4477153,50 48,50 C48.5522847,50 49,49.5522847 49,49 L49,47 C49,46.4477153 48.5522847,46 48,46 Z M53,46 C52.4477153,46 52,46.4477153 52,47 L52,49 C52,49.5522847 52.4477153,50 53,50 C53.5522847,50 54,49.5522847 54,49 L54,47 C54,46.4477153 53.5522847,46 53,46 Z M58,46 C57.4477153,46 57,46.4477153 57,47 L57,49 C57,49.5522847 57.4477153,50 58,50 C58.5522847,50 59,49.5522847 59,49 L59,47 C59,46.4477153 58.5522847,46 58,46 Z M28,46 C27.4477153,46 27,46.4477153 27,47 L27,49 C27,49.5522847 27.4477153,50 28,50 C28.5522847,50 29,49.5522847 29,49 L29,47 C29,46.4477153 28.5522847,46 28,46 Z M33,46 C32.4477153,46 32,46.4477153 32,47 L32,49 C32,49.5522847 32.4477153,50 33,50 C33.5522847,50 34,49.5522847 34,49 L34,47 C34,46.4477153 33.5522847,46 33,46 Z",
    id: "Shape",
    fill: "#B2C1DF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,22 L32,22 C32.5522847,22 33,21.5522847 33,21 C33,20.4477153 32.5522847,20 32,20 L28,20 C27.4477153,20 27,20.4477153 27,21 C27,21.5522847 27.4477153,22 28,22 Z M36,22 L50,22 C50.5522847,22 51,21.5522847 51,21 C51,20.4477153 50.5522847,20 50,20 L36,20 C35.4477153,20 35,20.4477153 35,21 C35,21.5522847 35.4477153,22 36,22 Z M28,30 L52,30 C52.5522847,30 53,29.5522847 53,29 C53,28.4477153 52.5522847,28 52,28 L28,28 C27.4477153,28 27,28.4477153 27,29 C27,29.5522847 27.4477153,30 28,30 Z M46,36 L42,36 C41.4477153,36 41,36.4477153 41,37 C41,37.5522847 41.4477153,38 42,38 L46,38 C46.5522847,38 47,37.5522847 47,37 C47,36.4477153 46.5522847,36 46,36 Z M38,36 L28,36 C27.4477153,36 27,36.4477153 27,37 C27,37.5522847 27.4477153,38 28,38 L38,38 C38.5522847,38 39,37.5522847 39,37 C39,36.4477153 38.5522847,36 38,36 Z M18,24.0000167 C18.265803,24.0015368 18.5212812,23.8971865 18.71,23.71 L22.71,19.71 C23.0497768,19.3132397 23.0269323,18.7218058 22.6575632,18.3524368 C22.2881942,17.9830677 21.6967603,17.9602232 21.3,18.3 L18,21.59 L16.71,20.3 C16.3132397,19.9602232 15.7218058,19.9830677 15.3524368,20.3524368 C14.9830677,20.7218058 14.9602232,21.3132397 15.3,21.71 L17.3,23.71 C17.4862606,23.8947442 17.7376601,23.9988954 18,24.0000167 Z",
    id: "Shape",
    fill: "#6F7FE2",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodoZeroState);
export default __webpack_public_path__ + "static/media/todo_zero_state.b61adf29f81152ba5572420d8ffa67ef.svg";
export { ForwardRef as ReactComponent };